import {type WorkspaceLayoutDisplayRowFnType} from '../types';
import {type WorkspaceLayoutTemplateSettings} from '../workspaceTemplatesQueries';
import {
  getAutoOrganizePrefixDisplayRow,
  getShowEmptySectionsDisplayRow,
  getSortAlphabeticallyDisplayRow,
} from './displayValues';

/**
 * Maps workspace layout setting keys to their display functions.
 */
export const WORKSPACE_LAYOUT_TEMPLATE_DISPLAY_FNS: Record<
  keyof WorkspaceLayoutTemplateSettings,
  WorkspaceLayoutDisplayRowFnType
> = {
  autoOrganizePrefix: getAutoOrganizePrefixDisplayRow,
  showEmptySections: getShowEmptySectionsDisplayRow,
  sortAlphabetically: getSortAlphabeticallyDisplayRow,
};
